/** Resume Clerk's existing attempt inside its hash router, never the new-signup start page. */
export function signUpCompletionUrl(
  authNextQuery: string,
  missingFields: readonly string[],
  unverifiedFields: readonly string[],
): string {
  const step = missingFields.length
    ? 'continue'
    : unverifiedFields.includes('email_address')
      ? 'verify-email-address'
      : unverifiedFields.includes('phone_number')
        ? 'verify-phone-number'
        : 'continue';
  return `/login/continue${authNextQuery}#/${step}`;
}
